import { memo } from 'react';
import { UseControllerProps, useController } from 'react-hook-form';
import { InputAutosize } from 'src/components/common';
import { InputAutosizeProps } from 'src/components/common/InputAutosize';

const FormInputAutosize = ({ control, ...props }: Props) => {
  const { field, fieldState } = useController({ name: props.name, control: control });

  return (
    <InputAutosize
      label={props.label}
      {...props}
      {...field}
      errorMessage={fieldState.error?.message}
    />
  );
};

type Props<T = any> = UseControllerProps<T> & InputAutosizeProps;

export default memo(FormInputAutosize);
